import AccountInformationSection from "./AccountInformationSection";
import $ from 'jquery'
import {isOlVersion} from "../../constants";

/**
 * Created by filatov on 20.01.2016.
 */
class EditAccountInformationSection extends AccountInformationSection {}

EditAccountInformationSection.prototype.init = function({
    lightBoxEl = null,
    userManagementData = null,
    currentTime = null,
    userId = null,
    accountSettings = null,
    changesCallback = () => {},
    validateCallback = () => {},
    checkUsernameErrorHandler = () => {},
    corporateSchedule = null,
    userGroupsEnabled = false,
    timeZoneGroupsEnabled = false,
    firstTTDate = null,
    firstLeaveRequestDate = null,
    editedUserIsSelf = false,
    handlerIfNoSuchUserAfterAjax = () => {},
    specificVersionDrawerConstructor = () => {},
    disableDuplicateUsernameCheck = false,
    disableEmptyUsernameCheck = false,
    scrollableContainerEl = null,
    showGroupRows = false,
    needValidation = true,
    releaseDateLabelEl = null,
    hireDateLabelEl = null,
}) {
    AccountInformationSection.prototype.init.call(this, {
        lightBoxEl,
        userManagementData,
        currentTime,
        userId,
        accountSettings,
        changesCallback,
        validateCallback,
        checkUsernameErrorHandler,
        corporateSchedule,
        userGroupsEnabled,
        timeZoneGroupsEnabled,
        firstTTDate,
        firstLeaveRequestDate,
        editedUserIsSelf,
        handlerIfNoSuchUserAfterAjax,
        specificVersionDrawerConstructor,
        disableDuplicateUsernameCheck,
        disableEmptyUsernameCheck,
        scrollableContainerEl,
        showGroupRows,
        needValidation,
        hireDateLabelEl,
    })
    this.releaseDateLabelEl = releaseDateLabelEl
    this.initAndShowReleaseDate(accountSettings.releaseDate, userManagementData)
    $(lightBoxEl).addClass("editMode");
    $(lightBoxEl).toggleClass("online", isOlVersion);
    $(lightBoxEl).toggleClass("downloadable", !isOlVersion);
    return this;
};

EditAccountInformationSection.prototype.initAndShowReleaseDate = function(releaseDate, userManagementData, editable = true){
    var self = this;

    this.releaseDatePlaceholderEl = this.getElementBySubId("releaseDatePlaceholder");
    this.releaseDatePlaceholderEl.innerHTML = "";

    const parsedDate = _.isString(releaseDate) ? Date.parseJSONDate(releaseDate): releaseDate

    this.releaseDateSelector = this.createDateSelector(
        userManagementData,
        "releaseDate",
        this.releaseDatePlaceholderEl,
        releaseDate,
        this.corporateSchedule,
        function() {
            $(self).trigger('releaseDateChanged', [self.getReleaseDate()])
        }
    )

    this.delReleaseDateBtn.style.display = releaseDate ? "inline-block" : "none"
    this.delReleaseDateBtn.onclick = function() {
        self.releaseDateSelector.unsetValue()
        self.releaseDateSelector.fireEvent("change", this)
    }
    this.releaseDateSelector.on("change", function() {
        self.delReleaseDateBtn.style.display = this.getValue() ? "inline-block" : "none"
    })
    //hide read-only release date row in edit user panel if there is no release date
    $(this.getElementBySubId("releaseDate")).toggle(editable || !!releaseDate)

    this._setReleaseDateLabel(parsedDate)

    this.releaseDateLabelEl.toggle(!editable)
    if (!editable) {
        this.releaseDateSelector.hide()
        $(this.delReleaseDateBtn).hide()
    }
};

EditAccountInformationSection.prototype.getReleaseDate = function()
{
    return this.releaseDateSelector.getValue();
};

EditAccountInformationSection.prototype.setReleaseDate = function(date, hireAndReleaseDatesEditable)
{
    this.delReleaseDateBtn.style.display = date ? "inline-block" : "none"
    if (date === null) {
        return this.releaseDateSelector.unsetValue();
    }
    const parsedDate = _.isString(date) ? Date.parseJSONDate(date): date
    this._setReleaseDateLabel(parsedDate)
    $(this.delReleaseDateBtn).toggle(hireAndReleaseDatesEditable)
    return this.releaseDateSelector.setValue(parsedDate);
};

EditAccountInformationSection.prototype._setReleaseDateLabel = function(date)
{
    if (!!date)
        this.releaseDateLabelEl.text(this.releaseDateSelector.formatDate(date))
};


export default EditAccountInformationSection



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/EditAccountInformationSection.js